'use client';
// Adaptateur : branche le LoginPanel partagé (shared/LoginPanel.tsx) sur le
// store GED. Avant ce fichier, l'espace Qualité n'avait aucune connexion à
// lui — le bouton « Se connecter » renvoyait vers le manuel (seule app qui
// avait ces routes), ce qui rend le module Qualité inutilisable dès que le
// manuel n'est pas démarré. Les routes /api/auth/login, /api/auth/2fa et
// /api/team/* existaient déjà en partagé ; il ne manquait que ce branchement.
import { useState } from 'react';
import { useGed } from '@/lib/store';
import { LoginPanel, type AccueilDuJour } from '@/shared/LoginPanel';
import type { Lang } from '@/shared/loginDict';

export function LoginView() {
  const boot = useGed((s) => s.boot);
  const [lang, setLang] = useState<Lang>('FR');

  const finalizeToken = typeof window === 'undefined' ? null
    : new URLSearchParams(window.location.search).get('finalize');

  return (
    <LoginPanel
      moduleSub="Qualité"
      lang={lang}
      onLang={setLang}
      onSuccess={() => void boot()}
      finalizeToken={finalizeToken}
      /* Le poste du jour sur l'écran de reconnaissance (27/08/2026). SEULE
         l'application Qualité passe cette prop : c'est la seule dont le
         mandataire Next ouvre la route RH. Le manuel et le site public
         gardent l'écran tel quel, sans un appel qui n'aboutirait pas. */
      chargerAccueil={async () => {
        const r = await fetch('/api/ged/ged/rh/mon-jour', { credentials: 'include' });
        if (!r.ok) return null;
        const d = await r.json();
        return d?.ok ? d as AccueilDuJour : null;
      }}
    />
  );
}
